import {
    PublicClientApplication,
    EndSessionRequest,
    SsoSilentRequest,
    InteractionRequiredAuthError,
} from '@azure/msal-browser';
import { msalConfig } from '../models/msal-auth-config';
import { ISession } from '../models/pro-sites';
import { IResult } from '../models/result-models';
import { apiGet, apiPut, setToken } from './api-utils';

const baseurl = process.env.REACT_APP_API_URL + '/session/';

const msalInstance = new PublicClientApplication(msalConfig);

const isSiteUpgraded = (country: string) =>
    ['US', 'FR', 'CA'].includes(country);

export const getSession = async (): Promise<IResult<ISession>> => {
    const result = await apiGet<ISession>(baseurl);

    if (result.data) {
        const session = result.data;
        const title = session.title || '';

        if (session.InsiteToken) {
            setToken(session.InsiteToken);
        }

        if (title.includes('KIND')) {
            session.primaryBrand = 'KIND';
        } else if (
            window.location.href.toLocaleLowerCase().includes('audibelpro.com')
        ) {
            session.primaryBrand = 'Audibel';
        } else if (
            window.location.href.toLocaleLowerCase().includes('nuearpro.com')
        ) {
            session.primaryBrand = 'NuEar';
        } else if (
            window.location.href
                .toLocaleLowerCase()
                .includes('miracle-earpro.com')
        ) {
            session.primaryBrand = 'MiracleEar';
        } else {
            session.primaryBrand = 'Starkey';
        }

        isSiteUpgraded(session.country)
            ? (session.isSiteUpgraded = true)
            : (session.isSiteUpgraded = false);
    }

    return result;
};

export const updateSession = async (
    session: ISession
): Promise<IResult<ISession>> => {
    const result = await apiPut<ISession, ISession>(baseurl, session);

    return result;
};

export const ssoSilent = async (): Promise<boolean> => {
    const ssoRequest: SsoSilentRequest = {
        loginHint: 'test@starkey.com',
    };

    await msalInstance
        .ssoSilent(ssoRequest)
        .then((result) => {
            return true;
        })
        .catch((error) => {
            if (
                error instanceof InteractionRequiredAuthError &&
                !window.location.href.includes('local')
            ) {
                sessionLogout();
            }
            return false;
        });
    return true;
};

export const sessionLogout = async (): Promise<void> => {
    await apiGet<void>(`${process.env.REACT_APP_SERVICES_URL}/session/logout`);

    const path = window.location.pathname;
    const currentAcc = msalInstance.getAllAccounts();
    if (currentAcc.length === 0) {
        window.location.href = '/login?' + path;
    }
    const logoutRequest: EndSessionRequest = {
        account: currentAcc[0],
    };
    sessionStorage.clear();
    localStorage.clear();
    msalInstance.logoutRedirect(logoutRequest);
};
